export default "__VITE_ASSET__C4CP8wTS__"